module.exports = __webpack_public_path__ + "img/iProspect.551f972d.png";